import type { JsonValue } from 'type-fest';

import { prepareAndMakeRequest } from '@frontend/api';

const chat = {
  acknowledgeChannelNotifications: (channelId: string): Promise<JsonValue> =>
    prepareAndMakeRequest.put<JsonValue>(
      `/notifications/chat/acknowledge_channel/${channelId}`,
    ),
  acknowledgeThreadNotifications: (annotationId: string): Promise<JsonValue> =>
    prepareAndMakeRequest.put<JsonValue>(
      `/notifications/chat/acknowledge_thread/${annotationId}`,
    ),
};

export default {
  chat,
  list: (params: {
    page?: number;
    filterOutAcknowledged?: boolean;
  }): Promise<{
    count: number;
    unacknowledgedCount: number;
    results: JsonValue;
  }> =>
    prepareAndMakeRequest.get<{
      count: number;
      unacknowledgedCount: number;
      results: JsonValue;
    }>('/notifications', { query: params }),
  patch: (
    notificationId: string,
    data: Record<string, JsonValue>,
  ): Promise<JsonValue> =>
    prepareAndMakeRequest.patch<JsonValue>(`/notifications/${notificationId}`, {
      body: data,
    }),
  markAllRead: (): Promise<JsonValue> =>
    prepareAndMakeRequest.patch('/notifications/read'),
  getThumbnail: (partFileUuid: string): Promise<JsonValue | Blob> =>
    prepareAndMakeRequest.get(`/parts/files/${partFileUuid}/thumbnail/`),
};
